import { render, staticRenderFns } from "./gljc.vue?vue&type=template&id=6b876368&scoped=true&"
import script from "./gljc.vue?vue&type=script&lang=js&"
export * from "./gljc.vue?vue&type=script&lang=js&"
import style0 from "./gljc.vue?vue&type=style&index=0&id=6b876368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b876368",
  null
  
)

export default component.exports